export default __webpack_public_path__ + "static/media/hauwa2.0815b4f9.jpg";